import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const PaymentIziPay = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const processId = queryParams.get("processId");
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    const fetchDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valet-process/${processId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.payment_status === "PAID") {
                setDetails(response.data);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching transaction details:", error);
        }
    };

    useEffect(() => {
        if (processId && token) {
            fetchDetails();
            const intervalId = setInterval(fetchDetails, 3000);
            return () => clearInterval(intervalId);
        }
    }, [processId, token]);

    if (loading) return <div>Procesando pago, por favor espera...</div>;
    if (!details) return <div>Error al cargar los detalles del pago.</div>;

    return (
        <div>
            <h2>Pago Exitoso</h2>
            <p>Gracias por su propina de {details.tip_to_valet} PEN al valet {details.valet_name}.</p>
            <p>ID De Transacción: {details.transaction_id}</p>
            <p>Tarjeta: **** **** **** {details.card_last_four}</p>
        </div>
    );
};

export default PaymentIziPay;